// extracted by mini-css-extract-plugin
module.exports = {"api-icon-container":"styles_api-icon-container__IN2za","api-icon":"styles_api-icon__nkiO_"};